import React from 'react';
import { DividerViewer } from '../viewer/divider-viewer.js';
import 'classnames';
import 'ricos-context';
import '../withSafariSvgCaretFixer-1ad529c9.js';
import '../style-inject.es-e7b07dd7.js';
import '../components/divider-line.js';
import 'prop-types';
import '../defaults.js';
import 'wix-rich-content-common';
import '../dataHooks.js';

const Divider = ({ componentData }) => {
  return /* @__PURE__ */ React.createElement(DividerViewer, { componentData });
};

export { Divider };
//# sourceMappingURL=component.js.map
